import Axios from "axios";

const state = {
  offerOptions: [],
  occupationOptions: [],
};

const getters = {
  offerOptions: (state) => state.offerOptions,
  occupationOptions: (state) => state.occupationOptions,
};
const mutations = {
  setOfferOptions: (state, bool) => {
    state.offerOptions = bool;
  },
  setOccupationOptions: (state, bool) => {
    state.occupationOptions = bool;
  },
};
const actions = {
  getDashboardOptions({ commit }) {
    Axios.get(window.baselink + "getDashboardOptions").then(function(response) {
      if (response.status == 200) {
        commit("setOfferOptions", response.data.offers);
        commit("setOccupationOptions", response.data.occupations);
      }
    });
  },
};

export default {
  namespace: "options",
  state,
  getters,
  actions,
  mutations,
};
